import VueTypes from 'vue-types'

export default {
  /**
   * 气泡框出现的位置
   * @type String
   */
  position: VueTypes.oneOf(['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end']).def('top'),
  /**
   * 气泡框的颜色
   * @type String
   */
  color: VueTypes.string.def('base'),
  /**
   * 是否禁用提示框
   * @type Boolean
   */
  disabled: VueTypes.bool.def(false),
  /**
   * 延迟显示，单位毫秒
   * @type Number
   */
  delay: VueTypes.number.def(0),
  /**
   * 是否显示方向箭头
   * @type String
   */
  arrow: VueTypes.bool.def(true),
  /**
   * 显示的内容
   * @type String | Array.<String>
   */
  label: VueTypes.oneOfType([String, Array]),
  /**
   * 是否是内联位置
   * @type Boolean
   */
  inner: VueTypes.bool.def(false),
  /**
   * 是否包含滚动过的宽度
   * @type Boolean
   */
  useScrollLeft: VueTypes.bool.def(false),
  /**
    * 是否包含滚动条的高度
    * @type Boolean
    */
  useScrollTop: VueTypes.bool.def(false)
}
